import { Autocomplete, Chip, TextField } from '@mui/material';

export interface ChipListInputProps {
  label: string;
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  helperText?: string;
  error?: boolean;
  size?: 'small' | 'medium';
}

/**
 * Free-text chip list editor (type + Enter to add). Used for the promo condition/restriction
 * fields that reference codes the BFF has no reference-list endpoint for (store codes, delivery
 * zones, payment/delivery method codes, product-set brand codes) — a local copy of the pattern in
 * `features/store-settings/ui/components/ChipListField.tsx` (FSD forbids importing another feature).
 */
export function ChipListInput({
  label,
  value,
  onChange,
  disabled = false,
  placeholder,
  helperText,
  error = false,
  size = 'small',
}: ChipListInputProps) {
  return (
    <Autocomplete
      multiple
      freeSolo
      size={size}
      disabled={disabled}
      options={[]}
      value={value}
      onChange={(_event, next) => onChange(next as string[])}
      renderTags={(tags, getTagProps) =>
        tags.map((tag, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip size="small" label={tag} key={key} {...tagProps} />;
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={value.length === 0 ? placeholder : undefined}
          helperText={helperText}
          error={error}
        />
      )}
    />
  );
}
